"use strict";function getRealtimeTracingStatus$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getRealtimeTracingStatus$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.realm.getRealtimeTracingStatus";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.13"},_a)),exports.getRealtimeTracingStatus$=getRealtimeTracingStatus$,exports.default=getRealtimeTracingStatus$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/realm/getRealtimeTracingStatus.js
// module id = 983
// module chunks = 106